import { ajax } from '../../../services/helper'
class ApiService {

    getAssetTypesData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/assetTypes/list"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

   
    getAssetTypeById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/assetTypes/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


   
    


    addAssetType = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/assetTypes/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    editAssetType = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/assetTypes/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Asset Types/services/apiservices.js